export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mf-footer">
      <div className="mf-footer-inner">
        <div className="mf-footer-brand">
          <h3>MilkFlow</h3>
          <p>Smart dairy management, made simple.</p>
        </div>

        <div className="mf-footer-col">
          <h4>Product</h4>
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#how-it-works">How It Works</a>
        </div>

        <div className="mf-footer-col">
          <h4>Company</h4>
          <a href="#contact">Contact</a>
          <a href="/login">Login</a>
        </div>

        <div className="mf-footer-col">
          <h4>Legal</h4>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms &amp; Conditions</a>
        </div>
      </div>

      <div className="mf-footer-bottom">
        &copy; {year} MilkFlow. All rights reserved.
      </div>
    </footer>
  )
}
